import angular from 'angular';
import template from './columns.html';
import fbtemplate from './builder/preview.html';

const columnsConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('columns', {
		title:                      'Columns',
		template,
		group:                      'layout',
		selectable:    true,
		settings:                   {
			clearOnHide: false,
			label:       'Columns',
			hideLabel:   true,
			input:       false,
			tableView:   false,
			key:         'columns',
			columns:     [
				{
					components: [],
					width:      6,
					offset:     0,
					push:       0,
					pull:       0,
				},
				{
					components: [],
					width:      6,
					offset:     0,
					push:       0,
					pull:       0,
				},
			],
		},
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.removeColumn = (/** @type {number} */ index) => {
				$scope.component.columns.splice(index, 1);
			};
			$scope.addColumn = () => {
				$scope.component.columns.push({
					components: [],
					width:      1,
					offset:     0,
					push:       0,
					pull:       0,
				});
			};
		},
		fbtemplate,
		icon:                       'fa fa-columns',
		noDndOverlay:               true,
		confirmRemove:              true,
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/columns/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			// Adjust column component setting from before width, offset...
			if (
				$scope.component.columns.length === 2
				&& $scope.component.columns[0].width === undefined
				&& $scope.component.columns[1].width === undefined
			) {
				$scope.component.columns[0].width = 6;
				$scope.component.columns[0].offset = 0;
				$scope.component.columns[0].push = 0;
				$scope.component.columns[0].pull = 0;
				$scope.component.columns[1].width = 6;
				$scope.component.columns[1].offset = 0;
				$scope.component.columns[1].push = 0;
				$scope.component.columns[1].pull = 0;
			}
		},
	});
};

export default angular.module('app').config(columnsConfig);
